module.exports = __webpack_public_path__ + "f9adb98c.png";